import script from "./Clinical.vue?vue&type=script&setup=true&lang=ts"
export * from "./Clinical.vue?vue&type=script&setup=true&lang=ts"

import "./Clinical.vue?vue&type=style&index=0&id=f9706aee&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9706aee"]])

export default __exports__